export default __webpack_public_path__ + "static/media/CIA-2024-Brochures.9e69b1c9.pdf";